export type FullyQualifiedUrl = string; // must starts with https://

export type ChannelInfo = {
  icon: React.ReactNode;
  label: string;
  placeholder: string;
  acceptedDomains: string[];
  handleToUrl: (handle: string) => FullyQualifiedUrl;
};

export const ALL_CHANNEL_KEYS = [
  "twitter",
  "instagram",
  "tumblr",
  "facebook",
  "discord",
  "behance",
  "youtube",
  "tiktok",
  "telegram",
] as const;

export type ChannelKey = (typeof ALL_CHANNEL_KEYS)[number];
